import React, {FC, useMemo} from 'react';
import {ElementModel} from "../../Elemnt/PostCategory_list/core/_models";
import {useListView} from "../../Elemnt/PostCategory_list/core/ListViewProvider";
import {toAbsoluteUrl} from "../../../../_metronic/helpers";
const API_URL = process.env.REACT_APP_API_URL

type prop = {
    data : ElementModel
}
const ElementItemsSelect : FC<prop> = ({data}) => {
    const {selected, onSelect,setSelected} = useListView()

    const isSelected = useMemo(() => selected.includes(data.id), [data.id, selected])
    const selectHandel =()=> {
        if (setSelected) {
            setSelected(data.id)
        }
    }
    if(data.picName!= undefined){
        return (
            <div onClick={selectHandel} className={`col-md-3 me-1 cursor-pointer ${isSelected && 'border border-1 border-primary'}`}>
                <div className="text-center">
                    <img className="img-fluid"  src={`${API_URL}/img/element/250/${data.picName}`} alt={data.title} />
                    <div>
                        <span>{data.title}</span>
                    </div>
                </div>
            </div>
        )
    }else {
        return (
            <div onClick={selectHandel} className={`col-md-3 me-1 cursor-pointer ${isSelected && 'border border-1 border-primary'}`}>
                <div className="text-center">
                    <img className="img-fluid"  src={toAbsoluteUrl('/media/avatars/300-2.jpg')} alt={data.title} />
                    <div>
                        <span>{data.title}</span>
                    </div>
                </div>
            </div>


        )
    }
};

export default ElementItemsSelect;